const translates = {
    'pt-BR': {
        format_date: '99/99/9999',
        email: 'E-mail inválido', //não informou ou e-mail inválido// página login
        password: 'Campo obrigatório', //não informou a senha //página login
        password_confirmation: {
            required: 'Campo obrigatório', //não informou a senha
            equalTo: 'A senha precisa ser igual a anterior', //não informou a mesma senha na confirmação de senha//página esqueci minha senha (confirmação) ou alteração de senha (logado)
        },
        fl_accept: 'Você precisa aceitar os termos de uso.', //quando não confirma os termos de uso na página de primeiro acesso //first-access
        name: 'Campo obrigatório', //não informou o nome //página primeiro acesso não encontrado
        phone: 'Campo obrigatório', //não informou o telefone //página  primeiro acesso não encontrado
        message: 'Campo obrigatório', //não digitou a mensagem //página contato
        emptySelect: 'SELECIONE',

        country: 'Campo obrigatório', //não informou o país //página meus dados
        city: 'Campo obrigatório', //não informou a cidade //página meus dados

        registration: 'Você precisa preencher a matrícula.', //não informou a matricula //página minhas aeronaves

        airplane_id: {
            require_from_group: 'Campo obrigatório', //modelo, página de solicitação de orçamento
        },
        airplane_notfound: {
            require_from_group: 'Campo obrigatório', //não informou a mensagem na solicitação do orçamento / "não encontrou aeronave"
        },

        all: 'TODOS',
    },
    en: {
        format_date: '9999-99-99',
        email: 'EN err Email',
        password: 'EN err Password',
        password_confirmation: {
            required: 'err password_confirmation',
            equalTo: 'senha diferente',
        },
        fl_accept: 'err accept terms', //first-access
        name: 'err Name', //first access notfound
        phone: 'err Phone', //first access notfound
        message: 'err Message', //contact
        emptySelect: 'SELECT',
        country: 'err Cidade', //meus dados
        city: 'err Cidade', //meus dados
        registration: 'err Matricula',
        airplane_id: {
            //orçamento
            require_from_group: 'err Modelo',
        },
        airplane_notfound: {
            require_from_group: 'err Text',
        },

        all: 'ALL',
    },
    es: {
        format_date: '9999-99-99',
        email: 'ES err Email',
        password: 'ES err Password',
        password_confirmation: {
            required: 'err password_confirmation',
            equalTo: 'senha diferente',
        },
        fl_accept: 'err accept terms', //first-access
        name: 'err Name', //first access notfound
        phone: 'err Phone', //first access notfound
        message: 'err Message', //contact
        emptySelect: 'SELECIONE',
        country: 'err Cidade', //meus dados
        city: 'err Cidade', //meus dados
        registration: 'err Matricula',
        airplane_id: {
            //orçamento
            require_from_group: 'err Modelo',
        },
        airplane_notfound: {
            require_from_group: 'err Text',
        },

        all: 'TODOS',
    },
};

export function getTranslatedMessages() {
    const language = document.querySelector('html').getAttribute('lang');
    return translates[language];
}
